const BASE = "Agent Dashboard";

/**
 * Derive a tab title from the URL alone — no query data needed, so detail
 * routes get a useful title without plumbing run/repo names through their
 * components. Anything unmatched is App.tsx's catch-all <NotFound/>.
 *
 * Must agree with react-router on what matches: it ignores trailing slashes
 * and letter case (no route sets `caseSensitive`), so `/stats/` and `/Stats`
 * both render Stats and must not be titled "Not found".
 */
export function titleForPath(rawPathname: string): string {
  const pathname = rawPathname.replace(/(.)\/+$/, "$1");
  const lower = pathname.toLowerCase();
  if (lower === "/") return `Live · ${BASE}`;
  if (lower === "/runs") return `Runs · ${BASE}`;
  // Captures come from the raw pathname so ids and repo names keep their case.
  const run = pathname.match(/^\/runs\/([^/]+)$/i);
  if (run?.[1]) return `Run ${decodeURIComponent(run[1]).slice(0, 8)} · ${BASE}`;
  if (lower === "/repos") return `Repos · ${BASE}`;
  const repo = pathname.match(/^\/repos\/([^/]+)\/([^/]+)$/i);
  if (repo?.[1] && repo[2]) {
    return `${decodeURIComponent(repo[1])}/${decodeURIComponent(repo[2])} · ${BASE}`;
  }
  if (lower === "/stats") return `Stats · ${BASE}`;
  if (lower === "/settings") return `Settings · ${BASE}`;
  return `Not found · ${BASE}`;
}
